import { createFileRoute } from '@tanstack/react-router'
import PageRegister from '@/pages/account/register'

export const Route = createFileRoute('/app/account/register/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <PageRegister emailCookieName="p2regemail" />
}
